<template>
  <div>
    <load-profile></load-profile>
    <b-card ref="container" id="container">
      <b-card-text class="mb-2">
        <h5>
          {{ $t("general.chatPageDescription") }}
        </h5>
      </b-card-text>
      <div class="mb-4">
        <b-card-text class="mb-2">
          <h4>{{ $t("general.pageTitle") }}</h4>
        </b-card-text>
        <div class="d-flex flex-row mb-2">
          <div class="flex-item--half">
            <b-form-input></b-form-input>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column mb-4">
        <b-card-text>
          <h4>{{ $t("general.qrCode") }}</h4>
        </b-card-text>
        <b-card-text class="mb-2">
          <img
            class="qr-code-img"
            src="https://chart.googleapis.com/chart?cht=qr&chs=240x240&data=https://lychunvira18.github.com&chld=L|1"
          />
        </b-card-text>
        <b-card-text>
          <b-button variant="primary">{{ $t("button.qrCode") }}</b-button>
        </b-card-text>
      </div>
      <div class="mb-4">
        <h4>{{ $t("general.chatPageURL") }}</h4>
        <div class="d-flex flex-row mb-2">
          <b-form-input readonly class="mr-2"></b-form-input>
          <b-button variant="primary" class="button--copy">{{
            $t("button.copyLink")
          }}</b-button>
        </div>
        <b-button variant="primary">{{
          $t("button.previewChatPage")
        }}</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BFormInput, BButton } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
    BFormInput,
    BButton,
  },
  setup() {
    const permissionType = "chat-page";
    return { permissionType };
  },
};
</script>

<style class="scss" scoped>
.button--copy {
  width: 100%;
  max-width: 160px;
}

.qr-code-img {
  margin: -12px;
}
</style>
